import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function CoursesPage() {
  return <InstituteCrudPage config={entityConfigs['courses']} />;
}
